import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Popped.module.css";
import { FaTimes } from "react-icons/fa";
import PrivacyPolicy from "../../components/privacy/Privacy";

const Popped = ({ onClose, title }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);

  const reciver = "Kerenaxelrod@gmail.com";
  const serverUrl =
    "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const webhookUrl =
    "https://hook.us1.make.com/btghlzqtwm5c0hw1xali1h2h973ii1pd";

  const getUtmParams = () => {
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    const utmData = {};
    
    utmKeys.forEach((key) => {
      const value = params.get(key);
      if (value) {
        utmData[key] = value;
      }
    });

    return utmData;
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPrivacyModalOpen(true);
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsPrivacyModalOpen(true);
  };

  const sendToWebhook = async (data) => {
    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        body: new URLSearchParams(data),
      });
      console.log("Webhook sent successfully", response.status);
    } catch (err) {
      console.error("Webhook error:", err);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const name = nameRef.current.value;
    const email = emailRef.current.value;
    const phone = phoneRef.current.value;

    if (!name || !email || !phone) {
      alert("אנא מלא את כל השדות");
      return;
    }

    setIsSubmitting(true);

    const serverData = {
      name,
      phone,
      email: email,
      reason: "קורסים",
      reciver,
    };

    const utmParams = getUtmParams();

    const webhookData = {
      name,
      phone,
      email,
      source: "hamisrad.co.il",
      timestamp: new Date().toISOString(),
      ...utmParams,
    };

    sendToWebhook(webhookData);

    try {
      const serverResponse = await fetch(serverUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(serverData),
      });

      if (!serverResponse.ok) {
        throw new Error("submit failed");
      }

      setIsSubmitting(false);
      navigate('/תודה');

    } catch (err) {
      console.error(err);
      alert("התרחשה שגיאה, נסה שוב מאוחר יותר");
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popped}>
        <FaTimes className={styles.closeIcon} onClick={handleClose} />

        <div className={styles.container}>
          <div className={styles.title}>לשריון שיחת התאמה לתוכנית</div>
          <div className={styles.subtitle}>מלאי את הטופס ואחזור אלייך בהקדם</div>
        </div>

        <div className={styles.formContainer}>
          <form className={styles.form} onSubmit={submitHandler}>
            <div className={styles.inputGroup}>
              <input
                type="text"
                className={styles.input}
                placeholder="שם מלא"
                ref={nameRef}
                required
                disabled={isSubmitting}
              />

              <input
                type="tel"
                className={styles.input}
                placeholder="נייד"
                ref={phoneRef}
                required
                disabled={isSubmitting}
              />

              <input
                type="email"
                className={styles.input}
                placeholder="אימייל"
                ref={emailRef}
                required
                disabled={isSubmitting}
              />

              {isPrivacyModalOpen && (
                <PrivacyPolicy
                  ownerName="קרן אקסלרוד - המשרד"
                  email="Kerenaxelrod@gmail.com"
                  phone="+972 50-891-9747"
                  domain="https://hamisrad.co.il/"
                  isOpen={isPrivacyModalOpen}
                  onClose={() => setIsPrivacyModalOpen(false)}
                  showButton={false}
                />
              )}

              <button
                type="submit"
                className={`${styles.button} ${
                  isSubmitting ? styles.buttonDisabled : ""
                }`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "שולח..." : "כן, אני רוצה שתחזרי אליי!"}
              </button>

              <div className={styles.termsText}>
                בהשארת פרטים אני מאשר/ת כי קראתי והסכמתי ל
                <button 
                  type="button"
                  className={styles.termsLink}
                  onClick={handleTermsClick}
                >
                  תנאי שימוש
                </button>
                {" "}ול
                <button 
                  type="button"
                  className={styles.termsLink}
                  onClick={handlePrivacyClick}
                >
                  מדיניות הפרטיות
                </button>
                .
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Popped;